import { render, staticRenderFns } from "./gzhNewsList.vue?vue&type=template&id=31f3c3c0&scoped=true&"
import script from "./gzhNewsList.vue?vue&type=script&lang=js&"
export * from "./gzhNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3c3c0",
  null
  
)

export default component.exports